import { get, post } from "utils/request"
import store from "store"
import { AFF_BALANCE, AFF_WITHDRAWS, AFF_AWARDS } from "store/ActionTypes"

export async function $getAffBalance() {
  const res = await get('/aff/balance', {})
  if (res.code === 0) {
    store.dispatch({ type: AFF_BALANCE, value: res.data })
  }
  return res
}

// 申请提现
export async function $affWithDraw(balance: number, alipay_account: string, name: string) {
  const res = await post('/aff/withdraws', {
    body: {
      balance,
      alipay_account,
      name,
    }
  })
  return res
}

// 提现记录
export async function $affWithdrawRecords(page: number, page_size: number) {
  const res = await get(`/aff/withdraws?page=${page}&page_size=${page_size}`, {})
  if (res.code === 0) {
    store.dispatch({ type: AFF_WITHDRAWS, value: res.data })
  }
  return res
}

export async function $affAwardRecords(page: number, page_size: number) {
  const res = await get(`/aff/rewards?page=${page}&page_size=${page_size}`, {})
  if (res.code === 0) {
    store.dispatch({ type: AFF_AWARDS, value: res.data })
  }
  return res
}

export async function $affSendCode(affiliate_code: string) {
  return await get(`/aff/info?affiliate_code=${affiliate_code}`, {})
}
//aff统计
export async function $affVisit(referrer: string, affiliate_code: string) {
  const res = await post('/2/aff/visit', {
    body: {
      referrer,
      affiliate_code
    }
  })
  return res
}
//添加aff推广域名
export async function $createAffdomain(domain: string) {
  const res = await post('/2/aff/domain', {
    body: {
      domain
    }
  })
  return res
}
//获取用户的useinfo
export async function $userInfo() {
  const options = {}
  const data = await get(`/2/user/info?t=${Date.now()}`, options)
  if (data.status === 'ok') {
   
    localStorage.setItem('UserInfo',JSON.stringify(data.data))
  }
  return data
}